import { listApiData } from "@hooks/utils/api";
import { catchSentryError } from "@utils/sentry";
import { getPublicImageUrl } from "@utils/storage";
import { useCallback, useEffect, useState } from "react";
import { decodeProjectDetail } from "catchment-common/decoders/project";
import { ProjectDetail } from "catchment-common/entities/project";
import { ProfileLineItem } from "catchment-common/interfaces/profile";
import { ProjectDetailLineItem } from "catchment-common/interfaces/project";

export const useListProject = (
  userProfile?: ProfileLineItem,
  archived?: boolean
) => {
  const [projects, setProjects] = useState<ProjectDetailLineItem[]>([]);
  const [isListProjectLoading, setIsListProjectLoading] =
    useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const listProjects = useCallback(
    async (organisationId: string, archived?: boolean) => {
      try {
        setIsListProjectLoading(true);

        const projectRes = await listApiData(
          "listProjectDetails",
          "projectDetail",
          organisationId,
          {
            archived: archived === true ? "true" : undefined
          }
        );
        const projectDetailLineItems = await Promise.all(
          projectRes.data.map((p) =>
            decodeProjectDetail(p as ProjectDetail, getPublicImageUrl)
          )
        );
        setProjects(projectDetailLineItems);
      } catch (e: any) {
        catchSentryError(e);
        setError("Could not list project details");
      } finally {
        setIsListProjectLoading(false);
      }
    },
    [getPublicImageUrl]
  );

  useEffect(() => {
    if (userProfile && archived !== undefined) {
      listProjects(userProfile.organisationId, archived);
    }
  }, [userProfile, archived]);

  return {
    error,
    isListProjectLoading,
    listProjects,
    projects
  };
};
